import { render, staticRenderFns } from "./create-work-item.vue?vue&type=template&id=f7a64416&scoped=true"
import script from "./create-work-item.js?vue&type=script&lang=js&external"
export * from "./create-work-item.js?vue&type=script&lang=js&external"
import style0 from "../../create-work-item/create-work-item.css?vue&type=style&index=0&id=f7a64416&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a64416",
  null
  
)

export default component.exports